<template>
	<el-dialog title="查看文件登记" :close-on-click-modal="false" :visible.sync="visible"
		width="1000px">
		<div class="el-dialog-div">
			<el-form :model="dataForm" ref="dataForm" label-width="120px" :inline="true">
				<el-row>
					<el-col :span="12">
						<el-form-item label="文件类型" prop="fileType">
							<el-select class="selItemInput" v-model="dataForm.fileType" placeholder="请选择" :disabled="true">
								<el-option v-for="item in documentTypeList" :key="item.displayValue"
									:label="item.displayName" :value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="文件名称" prop="fileName">
							<el-input class="selItemInput" v-model="dataForm.fileName" placeholder="文件名称" clearable
								style="width:300px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="送审单位" prop="examineCompany">
							<el-input class="selItemInput" v-model="dataForm.examineCompany" placeholder="送审单位" clearable
								style="width:300px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="接收时间" prop="receiveTime">
							<el-date-picker class="selItemInput" value-format="yyyy-MM-dd" clearable
								v-model="dataForm.receiveTime" type="date" style="width:300px" :disabled="true">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="接收人" prop="receiveMan">
							<el-input class="selItemInput" v-model="dataForm.receiveMan" placeholder="接收人" clearable
								style="width:300px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="份数" prop="fileNumber">
							<el-input class="selItemInput" v-model="dataForm.fileNumber" placeholder="份数" clearable
								style="width:300px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
					<el-form-item label="审查状态">
						<el-select v-model="dataForm.examineStatus" placeholder="请选择" clearable>
							<el-option v-for="item in examineList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col> -->
					<el-col :span="12">
						<el-form-item label="审查人" prop="examineMan">
							<el-input class="selItemInput" v-model="dataForm.examineMan" placeholder="审查人" clearable
								style="width:200px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审查时间" prop="examineTime">
							<el-date-picker class="selItemInput" value-format="yyyy-MM-dd" v-model="dataForm.examineTime"
								type="date" style="width:200px" :disabled="true">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审查意见" prop="examineSuggestion">
							<el-input class="selItemInput" v-model="dataForm.examineSuggestion" placeholder="审查意见" clearable
								style="width:300px" :disabled="true">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label=" ">
							<el-table v-if="dataForm.files && dataForm.files.length > 0" :data="dataForm.files" :cell-style="{ padding: '0px' }">
								<el-table-column type="index" label="序号" width="60">
								</el-table-column>
								<el-table-column prop="fileName" label="文件名" width="400" align="center">
									<template slot-scope="scope">
										<span >{{ dataForm.files[scope.$index].fileName }}</span>
									</template>、

								</el-table-column>
								<el-table-column label="操作" width="200" align="center">
									<template slot-scope="scope">
										<el-button size="mini" type="primary" @click="viewFile(scope.$index)">查看</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<el-row class="formBtnGroup">
				<el-button v-preventReClick type="primary" plain size="small" @click="visible = false">关闭</el-button>
			</el-row>
		</div>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "examination-view",
	data() {
		return {
			visible: false,
			inline: false,
			documentTypeList: [],
			action: "",
			dataForm: {
				recNo: '',
				fileName: '',
				examineCompany: '',
				receiveTime: '',
				receiveMan: '',
				fileType: '',
				examineTime: '',
				returnTime: '',
				examineSuggestion: '',
				returnStatus: '',
				returnReceiveMan: '',
				files: [],
				fileNumber: '',
				loadFileName: '',
				examineMan: '',
				fileUri: ''
			},
			examineList: [{
				value: '0',
				label: '审查中'
			}, {
				value: '1',
				label: '已审查'
			}],
		}
	},
	methods: {
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		init(id, fileType) {
			this.visible = true;
			this.dataForm = {
				recNo: '',
				fileName: '',
				examineCompany: '',
				receiveTime: '',
				receiveMan: '',
				fileType: '',
				examineTime: '',
				returnTime: '',
				examineSuggestion: '',
				returnStatus: '',
				returnReceiveMan: '',
				fileNumber: '',
				files: [],
				loadFileName: '',
				fileUri: '',
				examineMan: ''
			};
			this.dataForm.recNo = id ? id : 0;
			this.dataForm.receiveMan = $common.getItem("userName");
			this.dataForm.receiveTime = this.getCurrentTime()
			this.dataForm.fileType = fileType
			this.getDocumentTypeList();
			this.$nextTick(() => {
				// this.$refs["dataForm"].resetFields();
				if (this.dataForm.recNo) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/fileexamineinfo/info/${this.dataForm.recNo}`,
						method: 'get',
						params: this.$http.adornParams({
							recNo: this.dataForm.recNo
						})
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.dataForm = data.body;
						}
					})
				}
			})
		},
		//审查文件类型
		getDocumentTypeList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubmitDocumentType/" + $common.getItem("workNo") + "/" + $common.getItem("subjectNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.documentTypeList = data.body;
				}
			});
		},
		viewFile(index) {
			window.open(this.dataForm.files[index].fileUri);
		}

	}
}
</script>
<style scoped>
.el-dialog-div {
	height: 62vh;
	overflow-x: hidden;
}
</style>
